<div class="custom-tooltip below">
    <p *ngIf="isHeaderCell" class="array-tooltip text-center">
        {{ params.value }}
    </p>
    <ul *ngIf="!isHeaderCell" class="array-tooltip">
        <li *ngFor="let item of value">{{ item }}</li>
    </ul>
</div>
